document.addEventListener('DOMContentLoaded', () => {
	const searchBlock = document.querySelector('.baza-znan-archive__search');
	if (!searchBlock) return;

	const input  = searchBlock.querySelector('input[name="bz_search"]');
	const btn    = searchBlock.querySelector('button');
	const target = document.getElementById('baza-znan-content');

	const doSearch = () => {
		const value = input ? input.value.trim() : '';

		if (value) {
			const url = new URL(window.location.href);
			url.searchParams.set('bz_search', value);
			url.hash = 'baza-znan-content';
			window.location.href = url.toString();
		} else if (target) {
			target.scrollIntoView({ behavior: 'smooth' });
		}
	};

	if (btn) btn.addEventListener('click', doSearch);

	if (input) {
		input.addEventListener('keydown', (e) => {
			if (e.key === 'Enter') doSearch();
		});
	}
});
